import { registerTab } from "lib/@components/tabs"
import { REGIME_ASSETS_TAB } from "routes/asset-register/plugins/regime-display/regime-display.runtime"
import { and } from "lib/logic"
import { isInRegime } from "routes/facilities/lib/when-parent-item"
import { WeeklyPlanner } from "routes/plan/plugins/weekly-planner/weekly-planner"
import { registerFeature } from "lib/features"
import { isEnabled } from "lib/@components/feature"

export const FEATURE_FLAG_52_WEEK_PLANNER = registerFeature({
    numericalId: 2003,
    name: "52 Week Planner",
    id: "52WeekPlanner",
    description: `Enables 52 week planner tab inside of maintenance regimes.`,
    internalUseOnly: true,
})

registerTab({
    tab: REGIME_ASSETS_TAB,
    id: "weekly_planner",
    title: "52 Week Planner",
    predicate: and(isInRegime, () => isEnabled(FEATURE_FLAG_52_WEEK_PLANNER)),
    content: <WeeklyPlanner $lazy priority={190} />,
})
